module.exports = __webpack_public_path__ + "media/images/icons/material/menu-c8c38adfd6f36b9bccd1e267064c0fe2.svg";